import { render } from "./WorkbooksBundleV2.vue?vue&type=template&id=2c166ec2&scoped=true"
import script from "./WorkbooksBundleV2.vue?vue&type=script&lang=js"
export * from "./WorkbooksBundleV2.vue?vue&type=script&lang=js"

import "./WorkbooksBundleV2.vue?vue&type=style&index=0&id=2c166ec2&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c166ec2"],['__file',"src/views/post/WorkbooksBundleV2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c166ec2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c166ec2', __exports__)) {
    console.log('reload')
    api.reload('2c166ec2', __exports__)
  }
  
  module.hot.accept("./WorkbooksBundleV2.vue?vue&type=template&id=2c166ec2&scoped=true", () => {
    console.log('re-render')
    api.rerender('2c166ec2', render)
  })

}


export default __exports__